import { render, staticRenderFns } from "./point-type.vue?vue&type=template&id=83589b3c"
import script from "./point-type.vue?vue&type=script&lang=js"
export * from "./point-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83589b3c')) {
      api.createRecord('83589b3c', component.options)
    } else {
      api.reload('83589b3c', component.options)
    }
    module.hot.accept("./point-type.vue?vue&type=template&id=83589b3c", function () {
      api.rerender('83589b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/point-type.vue"
export default component.exports